import React from "react";

import Breadcrumbs from "../../../../components/BreadCrumbs";
import Card from "../../../../components/Card";
import { UIPageFormFooter } from "../../../../components/ui";
import ClientFormFields from "../../../Company-portal/Clients/ClientForm/ClientFormFields";
import useAdminEditClient from "../hooks/useAdminEditClient";

import "../../../Company-portal/Clients/ClientForm/ClientForm.scss";

const AdminEditClient = () => {
  const {
    clients,
    shared,
    inputsValidations,
    breadcrumbList,
    client,
    loading,
    updating,
    canEdit,
    formik,
    onCancel,
  } = useAdminEditClient();

  if (!canEdit) return null;
  if (loading && !client) return null;
  if (!client) return null;

  return (
    <div className="company-client-form edit-client">
      <Breadcrumbs list={breadcrumbList} BreadCrumbHasBackIcon={false} />

      <h2 className="page-title">
        {clients.editProfilePageTitle || clients.editProfile}
      </h2>

      <form onSubmit={formik.handleSubmit}>
        <Card
          title={clients.details}
          classNames={{ body: "company-portal-profile-card__body" }}
        >
          <ClientFormFields
            clients={clients}
            formik={formik}
            emailDisabled
            inputsValidations={inputsValidations}
          />
        </Card>

        <UIPageFormFooter
          cancelLabel={shared.cancel}
          submitLabel={clients.saveChanges || shared.save}
          onCancel={onCancel}
          submitType="submit"
          submitDisabled={!formik.dirty || !formik.isValid || updating}
          submitLoading={updating}
          cancelDisabled={updating}
        />
      </form>
    </div>
  );
};

export default AdminEditClient;
